// Valores no mesmo formato dos campos nativos: `aaaa-mm-dd` (data) e
// `aaaa-mm-ddThh:mm` (data e hora), sempre no horário local, sem fuso.
const pad = value => String(value).padStart(2, '0');

export const toDateKey = date =>
  `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`;

export const parseValue = value => {
  const match = /^(\d{4})-(\d{2})-(\d{2})(?:T(\d{2}):(\d{2}))?/.exec(
    value || ''
  );
  if (!match) return null;
  const [, year, month, day, hour = '0', minute = '0'] = match;
  const date = new Date(+year, +month - 1, +day, +hour, +minute);
  return date.getMonth() === +month - 1 ? date : null;
};

export const formatValue = (date, withTime) =>
  withTime
    ? `${toDateKey(date)}T${pad(date.getHours())}:${pad(date.getMinutes())}`
    : toDateKey(date);

export const displayValue = (value, withTime, locale = 'pt-BR') => {
  const date = parseValue(value);
  if (!date) return '';
  return new Intl.DateTimeFormat(locale, {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    ...(withTime ? { hour: '2-digit', minute: '2-digit', hour12: false } : {}),
  }).format(date);
};

// Semanas completas (domingo a sábado) que cobrem o mês exibido.
export const monthGrid = month => {
  const first = new Date(month.getFullYear(), month.getMonth(), 1);
  const start = new Date(first);
  start.setDate(1 - first.getDay());
  const weeks = Math.ceil(
    (first.getDay() +
      new Date(month.getFullYear(), month.getMonth() + 1, 0).getDate()) /
      7
  );
  return Array.from({ length: weeks * 7 }, (_, index) => {
    const day = new Date(start);
    day.setDate(start.getDate() + index);
    return day;
  });
};
